export { MAIN_COMMON_TEST_IDS } from './common.testIds';
export { MAIN_HOME_WIDGET_TEST_IDS } from './home-widget.testIds';
export { MAIN_SEARCH_FLIGHT_TEST_IDS } from './search-flight.testIds';
export { MAIN_SEARCH_HOTEL_TEST_IDS } from './search-hotel.testIds';
export { MAIN_SEARCH_CAR_TEST_IDS } from './search-car.testIds';
export { MAIN_SEARCH_TRANSFER_TEST_IDS } from './search-transfer.testIds';
export { MAIN_CHECKIN_TEST_IDS } from './checkin.testIds';
export { MAIN_MANAGE_FLIGHT_TEST_IDS } from './manage-flight.testIds';
export { MAIN_FLIGHT_STATUS_TEST_IDS } from './flight-status.testIds';
export { MAIN_LOGIN_TEST_IDS } from './login.testIds';
export { MAIN_RESET_PASSWORD_TEST_IDS } from './reset-password.testIds';
export { MAIN_BANNER_TEST_IDS } from './banner.testIds';
export { MAIN_CAROUSEL_TEST_IDS } from './carousel.testIds';
export { MAIN_OFFERS_TEST_IDS } from './offers.testIds';
export { MAIN_BENEFITS_TEST_IDS } from './benefits.testIds';
export { MAIN_ALLIANCE_TEST_IDS } from './alliance.testIds';
export { MAIN_FAQ_TEST_IDS } from './faq.testIds';
export { MAIN_SUBSCRIPTION_TEST_IDS } from './subscription.testIds';
export * from "./booking-flight";

